export default __webpack_public_path__ + "static/media/Gerald&EllenKitchen.32ece024.jpg";